const state = {
  isShowMaterial: false,
  materialListName: '',
}

const mutations = {
  show(state, materialListName) {
    document.body.style.overflow = 'hidden'
    console.log(materialListName)
    state.materialListName = materialListName;
    state.isShowMaterial = true;

  },
  hide(state) {
    document.body.style.overflow = 'auto'
    state.isShowMaterial = false
  },
}

const actions = {


}

const getters = {
  getIsShowMaterial: state => ()=> state.isShowMaterial
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
